import { startOfWeek, dayFormat } from '../week'

const baseUrl = ({ type, type_id }) =>
  type === 'service' ? `/services/${type_id}` : `/providers/${type_id}`

export const toGovRegistrationsByCareType = ({ id }) =>
  id ? `/gov-registrations/${id}` : '/gov-registrations'

export const toProviderRegistrations = id => `/providers/${id}/registrations`

export const toEnrolmentsByCareType = record => `${baseUrl(record)}/enrolments`

export const toSubmissionsByCareType = record => `${baseUrl(record)}/submissions`

export const toPaymentsByCareType = record => `${baseUrl(record)}/payments`

export const toPersonnel = record => `${baseUrl(record)}/personnel`

export const toIssCases = record => `${baseUrl(record)}/iss-cases`

export const toISSCaseClaims = record => `${baseUrl(record)}/iss-case-claims`

export const toSubmissionsFromEnrolments = enrolmentsUrl =>
  [enrolmentsUrl.replace('enrolments', 'submissions'), dayFormat(startOfWeek())].join('/')

export const toPaymentsFromSubmissions = submissionsUrl =>
  submissionsUrl.replace('submissions', 'payments')

export const toSubmissionsFromPayments = submissionsUrl =>
  submissionsUrl.replace('payments', 'submissions')

export const toReports = record => (record ? baseUrl(record) : '') + '/reports'

export const toParentApproval = ({ parent_id, care_id }) =>
  `/parents/${parent_id}/care-enrolments/${care_id}`



// WEBPACK FOOTER //
// ./src/navigate/index.js